<div class="modal-header">
  <h4 class="modal-title">Carga masiva desde Excel</h4>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<div class="modal-body">
  <p class="text-muted small mb-3">
    Use la plantilla con la hoja <code>Comuna_Producto_Precio</code>. El archivo se envía con el campo
    <code>excel</code> (formato .xlsx).
  </p>
  <p class="small mb-3">
    <a
      class="link-primary"
      href="/assets/admin/cemento/productos-cemento-carga-masiva-ejemplo.xlsx"
      download="productos-cemento-carga-masiva-ejemplo.xlsx"
      target="_blank"
      rel="noopener noreferrer"
    >
      Descargar plantilla de ejemplo (.xlsx)
    </a>
  </p>
  <label class="form-label d-block mb-2" for="prodCementoExcelFile">Archivo Excel</label>
  <input
    #excelFileInput
    type="file"
    id="prodCementoExcelFile"
    class="d-none"
    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    (change)="onExcelFileChange($event)"
  />
  <div class="productos-carga-masiva-acciones d-flex flex-column gap-3 align-items-stretch">
    <app-cbb-button
      label="Elegir archivo"
      color="outline"
      type="button"
      (action)="triggerExcelFileInput()"
    ></app-cbb-button>
    <p class="small mb-0 productos-carga-masiva-nombre" [class.text-muted]="!nombreArchivoExcel">
      {{ nombreArchivoExcel || 'Ningún archivo seleccionado' }}
    </p>
  </div>
  <div *ngIf="errorArchivoExcel" class="text-danger mt-2">
    Solo se permiten archivos Excel (.xlsx).
  </div>
</div>

<div class="modal-footer">
  <app-cbb-button
    label="Subir"
    color="green"
    (action)="onUpload()"
    [disabled]="!archivoExcel"
  ></app-cbb-button>
</div>
